import { IRegistry } from 'visyn_core/plugin';

try {
  // As visyn_pro is private, we can't import it directly: https://github.com/webpack/webpack/issues/15957
  // eslint-disable-next-line global-require, @typescript-eslint/no-var-requires, @typescript-eslint/no-require-imports
  require('visyn_pro/phovea_registry');
} catch (e) {
  console.error("Failed to load 'visyn_pro/phovea_registry'", e);
}

export default function register(registry: IRegistry) {
  /// #if include('extension-type', 'extension-id')
  // registry.push('extension-type', 'extension-id', () => import('./extension_impl'), {});
  /// #endif
  // generator-phovea:begin
  // registry.push(EP_PHOVEA_CORE_LOCALE, 'saberStellartLocaleEN', () => import('./locales/en/stellar.json').then(pluginRegistry.asResource), <ILocaleEPDesc>{
  //   order: 1,
  //   ns: 'stellar',
  // });
  // generator-phovea:end
}
